// @flow

import React from "react";

import { Col, Row, InfoSection } from "../../";

type Props = {
  options: Object,
};

export const PostWidgetInfoSection = (props: Props) => (
  <React.Fragment>
    {props.options.infoSectionText && props.options.showInfoSectionText ? (
      <Row className="mt-3">
        <Col>
          <InfoSection message={props.options.infoSectionText} />
        </Col>
      </Row>
    ) : null}
  </React.Fragment>
);

export default PostWidgetInfoSection;
